module.exports = __webpack_public_path__ + "static/img/arrow.0ce5b790.png";